module.exports = __webpack_public_path__ + "img/tiktok_logo.078e3b72.png";